/**
 * A refusal the Bedrock boundary wrote: a non-success response carrying a valid problem document.
 */
export class ProblemError extends Error {
    problem;
    constructor(problem) {
        super(`The request was refused with "${problem.code}" (${problem.status}).`);
        this.name = 'ProblemError';
        this.problem = problem;
    }
}
/**
 * An HTTP response that is not the Bedrock success or problem contract the call expected.
 *
 * It carries identifying metadata only — status, media type, URL and the reason. The response body
 * is deliberately absent: the bodies this class sees are the ones most likely to be sensitive, and
 * an excerpt is how a login page or a proxy error page reaches a log.
 */
export class UnexpectedResponseError extends Error {
    status;
    contentType;
    url;
    reason;
    constructor(reason, status, contentType, url) {
        super(`The response to ${url} was not a Bedrock response (${reason}, status ${status}).`);
        this.name = 'UnexpectedResponseError';
        this.reason = reason;
        this.status = status;
        this.contentType = contentType;
        this.url = url;
    }
}
/**
 * The request never produced a response: DNS, TLS, a reset connection, a CORS refusal.
 *
 * Caller cancellation is deliberately not this — an aborted request propagates the platform's own
 * `AbortError` unchanged, so a visitor navigating away is never counted as a network fault.
 */
export class NetworkError extends Error {
    url;
    constructor(url, cause) {
        super(`The request to ${url} could not be sent: ${String(cause)}`);
        this.name = 'NetworkError';
        this.url = url;
        this.cause = cause;
    }
}
/**
 * An unsafe same-origin request needed the antiforgery token and the page rendered none.
 *
 * Thrown before the request is issued. Sending it anyway would turn a client-side omission into a
 * server refusal indistinguishable from a real CSRF rejection.
 */
export class AntiforgeryTokenMissingError extends Error {
    constructor(message) {
        super(message);
        this.name = 'AntiforgeryTokenMissingError';
    }
}
//# sourceMappingURL=errors.js.map